<template>
  <div class="logo-area">
    <div class="logo" @dblclick="openDialog"></div>
    <div class="hospital-info">
      <h1>成都北新医院</h1>
      <p>Chengdu BeiXin Hospital</p>
    </div>
  </div>

  <!-- 登录弹窗 -->
  <transition name="fade">
    <div class="dialog-overlay" v-if="showDialog" @click="closeDialog">
      <div class="dialog-content" @click.stop>
        <!-- 关闭按钮 -->
        <button class="close-btn" @click="closeDialog">×</button>

        <!-- 弹窗标题 -->
        <div class="dialog-header">
          <h2>管理员登录</h2>
          <p>欢迎进入后台管理系统</p>
        </div>

        <!-- 表单区域 -->
        <form class="login-form" @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="username">用户名</label>
            <input
              type="text"
              id="username"
              v-model="username"
              placeholder="请输入用户名"
              autocomplete="username"
            />
          </div>

          <div class="form-group">
            <label for="password">密码</label>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="请输入密码"
              autocomplete="current-password"
            />
          </div>

          <button type="submit" class="login-btn">登 录</button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { authorizeManagementNavigation } from "@/utils/managementAccess";
import { longin } from "@/api/getInfo";

const router = useRouter();
const showDialog = ref(false);
const username = ref("");
const password = ref("");

const openDialog = () => {
  showDialog.value = true;
};

const closeDialog = () => {
  showDialog.value = false;
  username.value = "";
  password.value = "";
};

const handleLogin = async () => {
  if (!username.value || !password.value) {
    alert("请输入用户名和密码");
    return;
  }

  const loginInfo = await longin({
    username: username.value,
    password: password.value,
  });
  if (!loginInfo.data) {
    alert("用户名或密码错误");
    return;
  }

  authorizeManagementNavigation();
  router.push("/management");
  closeDialog();
};
</script>

<style scoped>
/* Logo 区域样式 */
.logo-area {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.logo-area:hover {
  opacity: 0.8;
}

.logo {
  width: 60px;
  height: 60px;
  background-image: url("/Other/hospitalLogo.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.hospital-info h1 {
  margin: 0;
  font-size: 1.3rem;
  color: #1a5fb4;
  text-align: center;
}

.hospital-info p {
  margin: 5px 0 0 0;
  font-size: 0.8rem;
  color: #666;
}

/* 弹窗遮罩层 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 弹窗内容 */
.dialog-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 40px 35px;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 420px;
  position: relative;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  line-height: 1;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #333;
  transform: rotate(90deg);
}

/* 弹窗标题 */
.dialog-header {
  text-align: center;
  margin-bottom: 30px;
}

.dialog-header h2 {
  margin: 0 0 8px 0;
  font-size: 1.8rem;
  color: #1a5fb4;
  font-weight: 600;
}

.dialog-header p {
  margin: 0;
  font-size: 0.95rem;
  color: #888;
}

/* 表单样式 */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 0.95rem;
  color: #555;
  font-weight: 500;
  padding-left: 4px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 1rem;
  color: #333;
  background-color: #fff;
  transition: all 0.3s ease;
  outline: none;
}

.form-group input:focus {
  border-color: #1a5fb4;
  box-shadow: 0 0 0 4px rgba(26, 95, 180, 0.1);
}

.form-group input::placeholder {
  color: #bbb;
}

/* 登录按钮 */
.login-btn {
  margin-top: 10px;
  padding: 14px;
  background: linear-gradient(135deg, #1a5fb4 0%, #0d47a1 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(26, 95, 180, 0.3);
  letter-spacing: 2px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(26, 95, 180, 0.4);
}

.login-btn:active {
  transform: translateY(0);
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .dialog-content {
    padding: 30px 25px;
    max-width: 90%;
  }

  .dialog-header h2 {
    font-size: 1.5rem;
  }

  .dialog-header p {
    font-size: 0.9rem;
  }

  .form-group input {
    padding: 11px 14px;
    font-size: 0.95rem;
  }

  .login-btn {
    padding: 13px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .dialog-content {
    padding: 25px 20px;
    border-radius: 12px;
  }

  .dialog-header h2 {
    font-size: 1.3rem;
  }

  .dialog-header p {
    font-size: 0.85rem;
  }

  .close-btn {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    font-size: 24px;
  }
}
</style>
